import { Property } from "./types";
import { StoreState } from "../types";

export const addedReducer = (state: StoreState, property: Property) => {
  return {
    ...state,
    properties: [...state.properties, property],
  };
};

export const editedReducer = (state: StoreState, property: Property) => {
  return {
    ...state,
    properties: [
      ...state.properties.filter((o) => o.id !== property.id),
      property,
    ],
  };
};

export const deletedReducer = (state: StoreState, id: string) => {
  return {
    ...state,
    properties: state.properties.filter((o) => o.id !== id),
  };
};

export const fetchedAllReducer = (
  state: StoreState,
  properties: Property[]
) => {
  localStorage.setItem("properties", JSON.stringify(properties));
  return {
    ...state,
    properties,
  };
};
